import { render, staticRenderFns } from "./email-template.vue?vue&type=template&id=6cd9606c&scoped=true&"
import script from "./email-template.vue?vue&type=script&lang=js&"
export * from "./email-template.vue?vue&type=script&lang=js&"
import style0 from "./email-template.vue?vue&type=style&index=0&id=6cd9606c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd9606c",
  null
  
)

export default component.exports